import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'

// import { Form } from 'informed'
import { useParams } from 'react-router-dom'

import * as moment from 'moment'

// import { DateTimePicker } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
// import Button from 'components/Button'
// import { DataTable } from 'components//DataTable'
import DataTable from 'components/DataTableTest'
import { useQuery, useLazyQuery } from 'components/graphql'
import { useMutation, updateQuery } from 'components/graphql'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'

// import CardImport from '../modals/History'
import DayOrderModal from '../modals/DayOrderModal'
// import { History } from '../../../media/icons'
import { listDateOrderValues } from '../gql'
import query from '../gql/getCreditClient'
import deleteDateOrderMutation from '../gql/mutation/deleteDayOrder'
import DatePeriod from '../modals/shared/DatePeriod'

import { dayOrder } from '../tableColumns'

const DayOrder = (props) => {
	const [t] = useTranslation()
	const { id } = useParams()
	const [dayOrderValueData, setDayOrderValueData] = useState({})
	const dateInterval = {
		to: moment(new Date()).utc().endOf('day').toISOString(),
		from: moment(new Date()).utc().startOf('day').toISOString()
	}
	const [addEditShow, setAddEditShow] = useState(false)
	const [deleteDateOrder] = useMutation(deleteDateOrderMutation)
	const isDisabled = props?.data?.FA_Id && (props.data.FA_Id !== null) && (props.data.FA_Id !== '') ? true : false

	let label = t('credit_client_section.strings.connected_with_registers') + ': '
	const itemData = useQuery(query, {
		fetchPolicy: 'cache-first',
		variables: { id: id }
	})

	if (itemData?.data?.getCreditClient?.connectedCRs) {
		const ccr = itemData.data.getCreditClient.connectedCRs.reduce((prev, cur) => (prev.concat(cur.name)), [])
		label += ccr.join(', ')
	}

	const [getData, { data, queryField: listQueryField }] = useLazyQuery(listDateOrderValues)
	const items = data?.[listQueryField]?.items || []

	const requestData = ({ value }) => {
		getData({ variables: { id, dateInterval: value.date } })
	}

	/* const requestData = (formData) => {
		if (formData?.dateInterval) {
			getData({ variables: { id, dateInterval: formData.dateInterval } })
		}
	} */

	/* const tableActions = [
		{
			label: t('credit_client_section.strings.history'),
			Icon: History,
			iconStyles: `margin-bottom: 6px;`,
			modalComponent: CardImport
		}
	] */

	const handleMutateRow = mutateVals => {
		// 'mutateVals' is id if deleting and 'mutateVals' is an object of vals if editing
		const isDeleting = typeof mutateVals === 'string' || typeof mutateVals === 'number'
		if (isDeleting) {
			const mutationName = getNameOfGqlQuery(deleteDateOrderMutation)
			deleteDateOrder({
				variables: { id: mutateVals },
				update: updateQuery({
					query: listDateOrderValues,
					variables: { id, dateInterval } }, (draft, { mutationResult, readQuery, queryField }) => {
					const oldItems = [...readQuery.items]
					const newItems = oldItems.filter((item = {}) => Number(item.id) !== Number(mutationResult.id))
					draft[queryField].items = newItems
				}),
				optimisticResponse: {
					cashAssist: {
						[mutationName]: {
							__typename: 'DateOrderValues',
							id
						},
						__typename: 'CA_Mutation'
					}
				}
			})
		} else {
			setDayOrderValueData({
				amount: mutateVals.amount,
				minAmount: mutateVals.minAmount,
				maxAmount: mutateVals.maxAmount,
				allottedAmount: mutateVals.allottedAmount,
				proposedAmount: mutateVals.proposedAmount,
				date: mutateVals.date,
				creditClientId: id,
				product: mutateVals.product,
				productId: mutateVals.product.id,
				id: mutateVals.id
			})
			setAddEditShow(true)
		}
	}

	return (
		<Fragment>
			<ContentBlock>
				{/* <Form
					onSubmit={requestData}
					initialValues={{ dateInterval }}
					render={({ formState })=>(
						<Fragment>
							<DateTimePicker
								picker='date'
								label={{ from: t('common.fields.from_date'), to: t('common.fields.to_date') }}
								field='dateInterval'
								interval/>
							<Button type='submit' status='primary' text={t('common.buttons.calculate')}/>
						</Fragment>
					)}/> */}
				<DatePeriod onChange={value => requestData({ value })} />
			</ContentBlock>
			<ContentBlock>
				<DataTable
					data={items}
					columns={dayOrder(t)}
					label={label}
					isInsideContentBlock={true}
					// tableActions={tableActions}
					withSelectRow
					withSearch
					onAddRecord={isDisabled ? false : () => {
						setDayOrderValueData({ creditClientId: id })
						setAddEditShow(true)
					}}
					mutateRow={isDisabled ? false : {
						editBtn: true,
						onRowMutate: handleMutateRow
					}}
				/>
			</ContentBlock>

			{addEditShow &&
				<DayOrderModal
					id={id}
					data={dayOrderValueData}
					unmount={() => setAddEditShow(false)}
					dateInterval={dateInterval}/>}
		</Fragment>
	)
}

export default DayOrder
